import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import AssetBrowser from '../components/AssetBrowser'

const AssetsPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="Digital Assets"
        subtitle="Browse and insert images, logos, and media"
      />
      
      <div className="page-content">
        <AssetBrowser onSelect={(asset) => {
          console.log('Asset selected:', asset)
          // Navigate back to document with asset
        }} />
      </div>
    </AppContainer>
  )
}

export default AssetsPage